import i18n from "i18next";
import backend from "i18next-http-backend";
import detector from "i18next-browser-languagedetector";
import { getConfig, translationUrl } from "./backend/helpers/urlHelper";
import { availableLanguages } from "./backend/constants/common";
import { IMFilesLanguages } from "./backend/interfaces/configuration/IBaseConfiguration";

const TRANSLATION_VERSION = 7; //Increase this every time when translations changes 

getConfig().then((config) => {
  const languages = config.uiLanguages ?? availableLanguages;
  i18n
    .use(backend)
    .use(detector)
    .init({
      ns: ["gantt", "mfiles"],
      defaultNS: "gantt",
      interpolation: { escapeValue: false }, 
      fallbackLng: languages,
      backend: {
        loadPath: (lng, ns) => {
          if(ns[0] === "mfiles") {
            const mFilesLanguages: IMFilesLanguages = config.mFilesLanguages ?? {};
            const mFilesLanguageCode = mFilesLanguages[lng[0]] ?? lng[0];
            return `${config.nvsApiUrl}${translationUrl(mFilesLanguageCode)}`;
          }
          return process.env.PUBLIC_URL + `/translations/${lng[0]}/${ns[0]}.json?v=${TRANSLATION_VERSION}`;
        },
      },
    });
}).catch((_err) => {
  //most likely we are running tests, use minimum configuration
  i18n.init({
    interpolation: { escapeValue: false }, 
    lng: "en",
    fallbackLng: "en",
    resources: { en: { translation: {} } },
  });
});

export default i18n;
